module.exports = __webpack_public_path__ + "static/img/42-3.c6c5360.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/42-3.jpg
// module id = IEVz
// module chunks = 0